import { useEffect } from 'react';
import { contact, defaultShareImage } from '../data/site';
import type { PageMeta } from '../types/content';

export function useSeo(meta: PageMeta, jsonLd?: Record<string, unknown>, image?: string) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : '';
  const shareImage = image ?? defaultShareImage;

  useEffect(() => {
    const url = `${contact.siteUrl}${meta.path}`;
    document.title = meta.title;
    upsertMeta('name', 'description', meta.description);
    upsertMeta('name', 'robots', meta.noIndex ? 'noindex, follow' : 'index, follow');
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:site_name', 'Liftoff Investments');
    upsertMeta('property', 'og:locale', 'en_GB');
    upsertMeta('property', 'og:title', meta.title);
    upsertMeta('property', 'og:description', meta.description);
    upsertMeta('property', 'og:url', url);
    upsertMeta('property', 'og:image', shareImage);
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', meta.title);
    upsertMeta('name', 'twitter:description', meta.description);

    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = url;

    document.getElementById('page-jsonld')?.remove();
    if (ld) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = 'page-jsonld';
      script.text = ld;
      document.head.appendChild(script);
    }
  }, [meta.path, meta.title, meta.description, meta.noIndex, ld, shareImage]);
}

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
